// extracted by mini-css-extract-plugin
export var socialManager = "bk_dD";